import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { fetchVRCsByAgent, fetchVRCs, deleteVRC } from '../../../Redux/Actions/actions';
import styles from './VRCList.module.css';

const VRCList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vrcs, vrcLoading, vrcError } = useSelector(state => state);
  const user = useSelector(state => state.user);
  const [deleting, setDeleting] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (user?.role === 'admin' || user?.role === 'superadmin') {
      dispatch(fetchVRCs());
    } else if (user?.user?.id || user?.userId) {
      dispatch(fetchVRCsByAgent(user?.user?.id || user?.userId));
    }
  }, [dispatch, user]);

  const handleDelete = async (id) => {
    if (!window.confirm('¿Seguro que querés eliminar este VRC?')) return;
    setDeleting(id);
    try {
      await dispatch(deleteVRC(id));
    } finally {
      setDeleting(null);
    }
  };

  const filtered = (vrcs || []).filter(v => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      v.propiedadData?.direccion?.toLowerCase().includes(term) ||
      v.propiedadData?.zona?.toLowerCase().includes(term) ||
      v.agente?.nombre?.toLowerCase().includes(term) ||
      v.propietario?.toLowerCase().includes(term)
    );
  });

  const formatCurrency = (val) => {
    if (!val) return '-';
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);
  };

  const formatDate = (iso) => {
    if (!iso) return '-';
    return new Date(iso).toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>Mis VRCs</h1>
          <p className={styles.subtitle}>{filtered.length} informe{filtered.length !== 1 ? 's' : ''}</p>
        </div>
        <Link to="/vrc-nuevo" className={styles.btnNew}>+ Nuevo VRC</Link>
      </div>

      <div className={styles.searchBar}>
        <input
          type="text"
          placeholder="Buscar por dirección, zona o propietario..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className={styles.searchInput}
        />
      </div>

      {vrcLoading && <div className={styles.loading}>Cargando...</div>}
      {vrcError && <div className={styles.error}>Error: {vrcError}</div>}

      {!vrcLoading && filtered.length === 0 && (
        <div className={styles.empty}>
          <div className={styles.emptyIcon}>📋</div>
          <h3>No hay VRCs aún</h3>
          <p>Creá tu primer informe de tasación VRC.</p>
          <Link to="/vrc-nuevo" className={styles.btnNew}>+ Nuevo VRC</Link>
        </div>
      )}

      <div className={styles.grid}>
        {filtered.map(vrc => (
          <div key={vrc.id || vrc._id} className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.tipoTag}>
                {vrc.propiedadData?.tipo === 'terreno' ? '🌿 Terreno' : '🏠 Edificado'}
              </div>
              <span className={styles.fecha}>{formatDate(vrc.createdAt)}</span>
            </div>

            <div className={styles.cardBody}>
              <h3 className={styles.direccion}>
                {vrc.propiedadData?.direccion || 'Sin dirección'}
              </h3>
              <p className={styles.zona}>{vrc.propiedadData?.zona || '-'}</p>

              {vrc.resultados?.vrcFinal && (
                <div className={styles.vrcValue}>
                  <span className={styles.vrcLabel}>VRC</span>
                  <span className={styles.vrcNum}>{formatCurrency(vrc.resultados.vrcFinal)}</span>
                </div>
              )}

              {vrc.propietario && (
                <p className={styles.propietario}>Propietario: {vrc.propietario}</p>
              )}
            </div>

            <div className={styles.cardActions}>
              {/* <button
                onClick={() => navigate(`/vrc-editar/${vrc.id || vrc._id}`)}
                className={styles.btnView}
              >
                Ver
              </button> */}
              <button
                onClick={() => navigate(`/vrc-editar/${vrc.id || vrc._id}`)}
                className={styles.btnEdit}
              >
                Editar
              </button>
              <button
                onClick={() => handleDelete(vrc.id || vrc._id)}
                disabled={deleting === (vrc.id || vrc._id)}
                className={styles.btnDelete}
              >
                {deleting === (vrc.id || vrc._id) ? '...' : 'Eliminar'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VRCList;
